module.exports = __webpack_public_path__ + "img/2038921599720838.e7bb1a06.jpg";